import {
  InvoiceExportSummary,
  InvoiceSearchResults,
  JournalEntries,
  PaginatedInvoices,
  SearchInvoiceResponse,
} from "types/model.types";
import { authApi } from "./";

export const getInvoices = async (
  pageNumber = 1,
  pageSize = 30,
): Promise<void | PaginatedInvoices> => {
  const { data } = await authApi.post<PaginatedInvoices>("invoice/get", {
    pageNumber,
    pageSize,
  });
  return data;
};

export const searchInvoices = async (
  searchTerm: string,
): Promise<InvoiceSearchResults> => {
  const response = await authApi.post<SearchInvoiceResponse>("invoice/search", {
    searchTerm,
  });

  return response.data.results ?? [];
};

export const getKnownInvoices = async (
  startDate: Date,
  endDate: Date,
): Promise<JournalEntries> => {
  const { data } = await authApi.post<JournalEntries>(
    "invoice/getKnownInvoices",
    {
      startDate,
      endDate,
    },
  );
  return data ?? [];
};
export const getKnownInvoicesByDebtor = async (
  id: number,
  months = 6,
): Promise<JournalEntries> => {
  const { data } = await authApi.post<JournalEntries>(
    "invoice/getKnownInvoicesByDebtor",
    {
      id,
      months,
    },
  );
  return data ?? [];
};
export const getInvoiceById = async (
  invoiceId: number,
): Promise<InvoiceExportSummary> => {
  const { data } = await authApi.post<InvoiceExportSummary>(
    "invoice/getInvoiceById",
    { invoiceId },
  );
  return data ?? [];
};
export const getCsvExportForUser = async (orderId: number): Promise<void> => {
  const response = await authApi.post(
    "invoice/getCsvExportForUser",
    { orderId },
    {
      responseType: "blob",
    },
  );

  const blob = new Blob([response.data], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = `order_${orderId}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
